import type { SectionProgress as Progress } from "../lib/sections";

/** The facet colours in order, as in the brand package's progress bar. */
const FILLS = ["bg-sun", "bg-coral", "bg-leaf", "bg-teal"];

/** Four columns: a thin 3px bar (one facet colour each) and a small label per section. */
export function SectionProgress({ sections }: { sections: Progress[] }) {
  return (
    <ol className="grid grid-cols-4 gap-1.5" aria-label="Sections">
      {sections.map((s, i) => (
        <li key={s.key} aria-current={s.current ? "step" : undefined} className="flex flex-col gap-1.5">
          <div className="h-[3px] w-full overflow-hidden rounded-full bg-line">
            <div className={`h-full rounded-full ${FILLS[i % FILLS.length]}`} style={{ width: `${Math.round(s.fill * 100)}%` }} />
          </div>
          <span className={`text-[11px] ${s.current ? "font-semibold text-ink" : "text-muted"}`}>{s.short}</span>
        </li>
      ))}
    </ol>
  );
}
